import { LottieView } from './LottieView';
export * from './types';
export default LottieView;
//# sourceMappingURL=index.js.map